import { Injectable } from "@angular/core";
import { Action } from "@ngrx/store";
import { ActionWithPayload } from "@obg/ngrx-utils";
import { AppError } from "@obg/ngx.core";

import { BalanceLimitState, BalanceLimitUpdate } from "./balance-limit.model";

const ACTION_PREFIX = "[Balance Limit]";

export const BALANCE_LIMIT_ACTION_TYPE = {
	get: `${ACTION_PREFIX} Get`,
	getSuccess: `${ACTION_PREFIX} Get Success`,
	getFail: `${ACTION_PREFIX} Get Fail`,

	update: `${ACTION_PREFIX} Update`,
	updateSuccess: `${ACTION_PREFIX} Update Success`,
	updateFail: `${ACTION_PREFIX} Update Fail`,

	reset: `${ACTION_PREFIX} Clear`,
};

@Injectable({
	providedIn: "root",
})
export class BalanceLimitAction {
	get(): Action {
		return {
			type: BALANCE_LIMIT_ACTION_TYPE.get,
		};
	}

	getSuccess(payload: BalanceLimitState): ActionWithPayload {
		return {
			type: BALANCE_LIMIT_ACTION_TYPE.getSuccess,
			payload,
		};
	}

	getFail(payload: AppError): ActionWithPayload {
		return {
			type: BALANCE_LIMIT_ACTION_TYPE.getFail,
			payload,
		};
	}

	update(payload: BalanceLimitUpdate): ActionWithPayload {
		return {
			type: BALANCE_LIMIT_ACTION_TYPE.update,
			payload,
		};
	}

	updateSuccess(): Action {
		return {
			type: BALANCE_LIMIT_ACTION_TYPE.updateSuccess,
		};
	}

	updateFail(payload: AppError): ActionWithPayload {
		return {
			type: BALANCE_LIMIT_ACTION_TYPE.updateFail,
			payload,
		};
	}

	reset() {
		return {
			type: BALANCE_LIMIT_ACTION_TYPE.reset,
		};
	}
}
